import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminPanel.css';

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

function ChangePassword() {
  const [formData, setFormData] = useState({
    old_password: '',
    new_password: '',
    confirm_password: ''
  });
  const navigate = useNavigate();
  const auth = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.new_password !== formData.confirm_password) {
      toast.error('A nova senha e a confirmação não correspondem.');
      return;
    }

    const csrftoken = getCookie('csrftoken');
    const config = { headers: { 'X-CSRFToken': csrftoken } };
    const dataToSend = {
        old_password: formData.old_password,
        new_password: formData.new_password
    };

    try {
      await axios.post('/api/change-password/', dataToSend, config);
      
      toast.success('Senha alterada com sucesso! Por favor, faça o login novamente.');
      
      // --- AQUI ESTÁ A CORREÇÃO ---
      // Usamos a nova função que só age no frontend
      auth.clientSideLogout(); 
      
      navigate('/login');

    } catch (error) {
      if (error.response && error.response.data.old_password) {
          toast.error(error.response.data.old_password[0]);
      } else if (error.response && error.response.data.new_password) {
          toast.error(`Nova senha inválida: ${error.response.data.new_password[0]}`);
      }
      else {
          toast.error('Não foi possível alterar a senha. Tente novamente.');
      }
      console.error('Erro ao alterar senha!', error.response);
    }
  };

  return (
    <div className="admin-container">
      <h1>Alterar Senha</h1>
      <div className="admin-section">
        <form onSubmit={handleSubmit} className="session-form">
          <input name="old_password" value={formData.old_password} onChange={handleChange} placeholder="Senha Atual" type="password" required />
          <input name="new_password" value={formData.new_password} onChange={handleChange} placeholder="Nova Senha" type="password" required />
          <input name="confirm_password" value={formData.confirm_password} onChange={handleChange} placeholder="Confirme a Nova Senha" type="password" required />
          <button type="submit">Salvar Nova Senha</button>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;